var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.676 3a.5.5 0 0 1 .5-.5h2.118a.5.5 0 0 1 0 1H7.176a.5.5 0 0 1-.5-.5m4.91.7a.5.5 0 0 1 .708-.002l1.058 1.053a.5.5 0 0 1-.704.709l-1.06-1.053a.5.5 0 0 1-.001-.707M8.237 5.08C6.17 5.079 4.5 6.743 4.5 8.789S6.17 12.5 8.235 12.5s3.736-1.664 3.736-3.71-1.67-3.711-3.736-3.711M3.5 8.789c0-2.604 2.123-4.71 4.735-4.71s4.736 2.106 4.736 4.71S10.848 13.5 8.235 13.5 3.5 11.394 3.5 8.79m4.735-2.605a.5.5 0 0 1 .5.5V8.79a.5.5 0 1 1-1 0V6.684a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
};
export { SvgTimer as ReactComponent };
export default __webpack_public_path__ + "72be0079401624b386a90c2524b3886d.svg";